module.exports = __webpack_public_path__ + "img/EA155&156.e9ac0d10.png";